import { useMemo } from 'react';
import { SelectProps } from '@radix-ui/react-select';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@antimatterhq/ui/components/select';
import { Text } from '@antimatterhq/ui/components/typography';
import { JoinTypeOptions } from '@/zod/schemas/StreamTableSchema';

export type JoinTypeDropdownProps = {
  onBlur?: () => void;
  'data-testid'?: string;
} & Pick<SelectProps, 'value' | 'onValueChange' | 'name' | 'disabled'>;

const FormatOption = ({ name }: { name?: string }) => {
  return <Text>{name}</Text>;
};

const OPTIONS = JoinTypeOptions.filter((option) => !!option);

export default function JoinTypeDropdown({
  value,
  onValueChange,
  onBlur,
  'data-testid': dataTestId,
  ...props
}: JoinTypeDropdownProps) {
  const selectedOption = useMemo(
    () => OPTIONS.find((option) => option === value),
    [value],
  );

  return (
    <Select value={value} onValueChange={onValueChange} {...props}>
      <SelectTrigger
        onBlur={onBlur}
        className="max-w-form"
        data-testid={dataTestId}
      >
        <SelectValue placeholder="Select a join type">
          {selectedOption && <FormatOption name={selectedOption} />}
        </SelectValue>
        <SelectContent>
          {OPTIONS.map((option) => (
            <SelectItem
              key={option}
              value={option}
              data-testid={`${dataTestId}-option-${option}`}
            >
              <FormatOption name={option} />
            </SelectItem>
          ))}
        </SelectContent>
      </SelectTrigger>
    </Select>
  );
}
